import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, ChevronRight, ExternalLink, Globe } from 'lucide-react';
import logo from '../assets/logo/VJ-College-logo.png';

export default function Footer() {
  return (
    <footer className="footer pt-5 pb-4 mt-5">
      <div className="container">
        <div className="row g-4 g-lg-5">
          {/* Column 1: College Info */}
          <div className="col-lg-4 col-md-6 text-start">
            <div className="d-flex align-items-center gap-3 mb-3">
              <img src={logo} alt="Vidyajyoti Logo" style={{ width: '52px', height: '52px' }} />
              <div>
                <h4 className="text-white fw-bold mb-0 fs-5">Vidyajyoti College</h4>
                <span className="text-gold small fw-semibold">Institute of Religious Studies</span>
              </div>
            </div>
            <p className="text-slate-300 small mt-3" style={{ lineHeight: '1.7', color: '#cbd5e1' }}>
              Vidyajyoti College of Theology is a premier Jesuit ecclesiastical faculty dedicated to transformative theological formation, contextual reflection, and service to society.
            </p>
            <div className="d-flex gap-2 mt-4">
              <a href="https://facebook.com" target="_blank" rel="noreferrer" className="btn-square" title="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://youtube.com/@vidyajyoticollegeoftheology" target="_blank" rel="noreferrer" className="btn-square" title="YouTube">
                <i className="fab fa-youtube"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" className="btn-square" title="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://vidyajyoticollege.in" target="_blank" rel="noreferrer" className="btn-square" title="Official Portal">
                <Globe size={18} />
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="col-lg-2 col-md-6 text-start">
            <h5 className="text-white fw-bold fs-6 mb-3 text-uppercase" style={{ letterSpacing: '0.05em' }}>
              Quick Links
            </h5>
            <div className="d-flex flex-column gap-2 small">
              <Link to="/about/vision-mission" className="d-flex align-items-center gap-1 text-slate-300">
                <ChevronRight size={14} className="text-gold" /> About Us
              </Link>
              <Link to="/academics/bachealor" className="d-flex align-items-center gap-1 text-slate-300">
                <ChevronRight size={14} className="text-gold" /> Academic Programs
              </Link>
              <Link to="/admission/details" className="d-flex align-items-center gap-1 text-slate-300">
                <ChevronRight size={14} className="text-gold" /> Admissions
              </Link>
              <Link to="/library/about" className="d-flex align-items-center gap-1 text-slate-300">
                <ChevronRight size={14} className="text-gold" /> College Library
              </Link>
              <Link to="/gallery/photo" className="d-flex align-items-center gap-1 text-slate-300">
                <ChevronRight size={14} className="text-gold" /> Photo Gallery
              </Link>
              <Link to="/contact" className="d-flex align-items-center gap-1 text-slate-300">
                <ChevronRight size={14} className="text-gold" /> Contact & Location
              </Link>
            </div>
          </div>

          {/* Column 3: External Institutional Links */}
          <div className="col-lg-2 col-md-6 text-start">
            <h5 className="text-white fw-bold fs-6 mb-3 text-uppercase" style={{ letterSpacing: '0.05em' }}>
              Affiliations
            </h5>
            <div className="d-flex flex-column gap-2 small">
              <a href="https://vidyajyotijournal.com" target="_blank" rel="noreferrer" className="d-flex align-items-center gap-1 text-slate-300">
                <ExternalLink size={13} className="text-gold" /> VJTR Journal
              </a>
              <a href="https://www.vjdepth.in/" target="_blank" rel="noreferrer" className="d-flex align-items-center gap-1 text-slate-300">
                <ExternalLink size={13} className="text-gold" /> VJ DEPTh
              </a>
              <a href="https://jcsaweb.org" target="_blank" rel="noreferrer" className="d-flex align-items-center gap-1 text-slate-300">
                <ExternalLink size={13} className="text-gold" /> JCSA / JERES
              </a>
              <a href="https://iaju.org" target="_blank" rel="noreferrer" className="d-flex align-items-center gap-1 text-slate-300">
                <ExternalLink size={13} className="text-gold" /> IAJU Global
              </a>
              <Link to="/privacy-policy" className="d-flex align-items-center gap-1 text-slate-300">
                <ChevronRight size={14} className="text-gold" /> Privacy Policy
              </Link>
            </div>
          </div>

          {/* Column 4: Contact Us */}
          <div className="col-lg-4 col-md-6 text-start">
            <h5 className="text-white fw-bold fs-6 mb-3 text-uppercase" style={{ letterSpacing: '0.05em' }}>
              Get In Touch
            </h5>
            <div className="d-flex flex-column gap-3 small text-slate-300">
              <div className="d-flex align-items-start gap-2">
                <MapPin size={18} className="text-gold flex-shrink-0 mt-1" />
                <span>4A, Raj Niwas Marg, Civil Lines, Delhi – 110054, India</span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <Phone size={18} className="text-gold flex-shrink-0" />
                <a href="tel:+919971186877" className="text-slate-300">(+91) 99711 86877</a>
              </div>
              <div className="d-flex align-items-center gap-2">
                <Mail size={18} className="text-gold flex-shrink-0" />
                <a href="mailto:vidyajyotic@gmail.com" className="text-slate-300">vidyajyotic@gmail.com</a>
              </div>
              <div className="d-flex align-items-center gap-2">
                <Mail size={18} className="text-gold flex-shrink-0" />
                <a href="mailto:principalvj@gmail.com" className="text-slate-300">principalvj@gmail.com</a>
              </div>
            </div>
          </div>
        </div>

        <hr className="my-4" style={{ borderColor: 'rgba(255, 255, 255, 0.12)' }} />

        <div className="row align-items-center small" style={{ color: '#94a3b8' }}>
          <div className="col-md-6 text-center text-md-start mb-2 mb-md-0">
            <span>© {new Date().getFullYear()} Vidyajyoti College of Theology. All rights reserved.</span>
          </div>
          <div className="col-md-6 text-center text-md-end">
            <span>Designed &amp; Maintained by <a href="https://idntica.com" target="_blank" rel="noreferrer" className="text-gold">Idntica</a> | Version : 2.0.1</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
